<template>
    <div class="c-row lottery-usage-advanced">
        <div class="c-tr">
            <div class="c-tw w-left">
                <div class="c-td is-1">
                    <div class="typo-label">Nazwa loterii adv</div>
                    <h3 class="c-promos-title h6">
                        {{ data.lottery.name }}
                    </h3>
                </div>
                <div class="c-td is-2">
                    <div class="typo-label">Nazwa sklepu / Adres</div>
                    <h3 class="c-promos-title h6">
                        {{ data.merchant.name }}
                    </h3>
                    {{ data.merchant.street }} {{ data.merchant.number }},
                    {{ data.merchant.postcode }} {{ data.merchant.city }},
                    {{ data.merchant.province }}
                </div>
            </div>
            <div class="c-tw w-right">
                <div class="c-td is-4 text-center">
                    <div class="typo-label">Spalony kod</div>
                    {{ data.transactions_log.code }}
                </div>
                <div class="c-td is-5 text-center">
                    <div class="typo-label">Kwota refundacji</div>
                    {{ data.refund }}
                </div>
                <div class="c-td is-6">
                    <div class="typo-label">Data oraz godzina użycia</div>
                    {{
                        this.$moment(data.created_at).format(
                            'DD-MM-YYYY HH:mm:ss'
                        )
                    }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showShops: false
        }
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    computed: {
        merchant() {
            return this.$store.getters.getMerchantById(this.data.merchantId)
        }
    }
}
</script>
